import MaterialTable, { MTableToolbar } from 'material-table';
import { useEffect, useState } from "react";
import {
    Box,
    Button,
    Grid,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import { useSelector, useDispatch } from 'react-redux';
import { GetTeamBalanceAction } from '../../../../../store/Leave/MyTeam/Action';
import Popup from '../../../Base/views/Popup';
import { GetUserWorkLocationHelper } from '../../../Employee/helper/EmployeeHelper';
import SelectableMultiSelect from '../../../Base/views/SelectableMultiSelect';
// import { UpdateTeamBalanceHelper } from '../../helper/TimeOff/TimeOffHelper';

const TeamBalanceGrid = () => {
    const dispatch = useDispatch();
    const [currentData, setCurrentData] = useState({});
    const [openPopup, setOpenPopup] = useState(false);
    const { TeamBalanceData, isLoading } = useSelector(state => state?.LeaveReducer.TimeSheetApprovalReducer);
    const [filters, setFilters] = useState({
        ats_work_location_id: []
    });
    const [worklocationData, setWorklocationData] = useState({
                load: true,
                values: [],
            });
    const handleWorkLoacation = () => {
        GetUserWorkLocationHelper().then(res => {
        if(res?.data?.statuscode === 200){
            setWorklocationData({ load: false, values: res?.data?.data || [] })
        } else {
            setWorklocationData({ load: false, values: [] })
        }
        })
    }
    const handleFilterChange = (event, value) => {
        if (["ats_work_location_id"].includes(event)) {
        if (value) {
            setFilters({ ...filters, [event]: value });
        } else {
            setFilters({ ...filters, [event]: "" });
        }
        }
    }
    const showWorkLocation = !worklocationData.load && worklocationData.values.length > 1;

    useEffect(() => {
        const locationPayload = JSON.stringify((filters?.ats_work_location_id || [])?.map((item) => ({ ats_work_location_id: item?.work_location_id })));
        dispatch(GetTeamBalanceAction({
            ats_work_location_json: (filters?.ats_work_location_id || [])?.length > 0 ? locationPayload : null,
        }));
        //eslint-disable-next-line
    }, [filters]);
    useEffect(() => {
        handleWorkLoacation();
        //eslint-disable-next-line
    }, []);
    const leaveTypes = new Set();
    TeamBalanceData?.forEach(employee => {
        employee?.leave_balances?.forEach(leave => {
            leaveTypes.add(leave?.name);
        });
    });

    const columns = [
        { title: "Name", field: "employee_name", cellStyle: { padding: "5px 0px 5px 13px" } },
        { title: "Location", field: "work_location_name", cellStyle: { padding: "5px 0px 5px 13px" }, hidden: !showWorkLocation, render: (rowData) => rowData?.work_location_name || "N/A" },
        ...Array.from(leaveTypes)?.map(leaveType => ({
            title: leaveType,
            field: leaveType,
            cellStyle: { padding: "5px 0px", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            render: rowData => {
            const value = rowData[leaveType];
            return value === null
                ? (
                <Tooltip title="The leave crediting cron job hasn’t run yet for this leave type.">
                    <span style={{ color: "inherit", cursor: "default" }}>N/A</span>
                </Tooltip>
                )
                : value;
            }
        })),
    ];

    const transformedData = TeamBalanceData?.map(employee => {
        const leaveBalanceData = {};
        employee?.leave_balances?.forEach(leave => {
            leaveBalanceData[leave?.name] = leave?.leavebalance;
        });
        return {
            employee_name: employee.employee_name,
            work_location_name: employee?.work_location_name,
            ...leaveBalanceData
        };
    });
    // const handleEdit = (event, row) => {
    //     setCurrentData(row)
    //     setOpenPopup(true);
    // };
    // const handleUpdate = () => {
    //     setOpenPopup(false);
    //     UpdateTeamBalanceHelper({
    //         currentData: currentData
    //     }).then((res) => {
    //         if (res?.data?.statuscode === 200) {
    //             // dispatch(GetEmployeesAction({ is_active: true }));
    //             setOpenPopup(false);
    //         }
    //     })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };
    return (
        <>
            <MaterialTable
                isLoading={isLoading}
                columns={columns}
                data={transformedData}
                options={{
                    maxBodyHeight: "calc(100vh - 235px)",
                    minBodyHeight: "calc(100vh - 235px)",
                    rowStyle: { fontSize: "13px" },
                    headerStyle: { padding: "10px 10px 10px 10px", fontWeight: "bold" },
                    sorting: false,
                    search: true,
                    searchFieldAlignment: "right",
                    searchAutoFocus: true,
                    searchFieldVariant: "standard",
                    paging: true,
                    pageSizeOptions: [25, 50],
                    pageSize: 25,
                    paginationType: "stepped",
                    showFirstLastPageButtons: false,
                    paginationPosition: "bottom",
                    exportFileName: "Team Leave Balance",
                    exportAllData: true,
                    exportButton: true
                }}
                title=""
                components={{
                    Toolbar: (props) => (
                        <Box sx={{ width: "full", display: "flex", flexDirection: { xs: "column", sm: "row" }, flexGrow: 1 }}>
                            <Box
                                sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                backgroundColor: "#f3edfd",
                                padding: "0px 0px 0px 20px",
                                flexGrow: 1,
                                minHeight: "48px !important",
                                }}
                            >
                            <Box>
                                <Typography variant='h6'>
                                    Team Leave Balance
                                </Typography>
                            </Box>
                            {showWorkLocation && (
                                <Box sx={{width: "210px", display: "flex", alignItems: "center", pt: 0.5}}>
                                    <SelectableMultiSelect
                                        multiple
                                        label="Location"
                                        placeholder="Select Location"
                                        value={filters?.ats_work_location_id}
                                        loading={handleWorkLoacation}
                                        fieldLabel="work_location_name"
                                        name="ats_work_location_id"
                                        size="small"
                                        onChangeEvent={handleFilterChange}
                                        data={worklocationData}
                                        menuHeight={150} // optional
                                    />
                                </Box> 
                            )}
                            </Box>
                              <Box
                                sx={{
                                    "& .MuiToolbar-root": {
                                    padding: "8px 16px !important",
                                    margin: "0 !important",
                                    minHeight: "48px !important",
                                    },
                                    "& .MuiFormControl-root": {
                                    margin: "0 !important",
                                    },
                                    "& .MuiInputBase-root": {
                                    marginLeft: "-20px !important",
                                    }
                                }}
                                >
                                    <MTableToolbar {...props} />
                                </Box>
                            </Box>
                    ),
                }}
            />
            <Popup
                title="Edit Team Leave Balance"
                openPopup={openPopup}
                setOpenPopup={setOpenPopup}
                fullWidth={true}
                maxWidth="sm"
            >
                <Box>
                    <Typography sx={{ mb: 2 }} variant="h5"> Employee Name : {currentData?.employee_name}</Typography>
                    <Grid container spacing={2}>
                        {Object.entries(currentData)
                            .filter(([key]) => (key !== "employee_name" && key !== "tableData"))
                            .map(([key, value], index) => (
                                <Grid item xs={12} sm={6} key={index}>
                                    <TextField
                                        label={key}
                                        type="number"
                                        value={value}
                                        size='small'
                                        onChange={(e) =>
                                            setCurrentData({
                                                ...currentData,
                                                [key]: e.target.value,
                                            })
                                        }
                                        fullWidth
                                    />
                                </Grid>
                            ))}
                    </Grid>
                    <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
                        <Button
                            className="mpl-primary-btn"
                            onClick={() => setOpenPopup(false)}
                            sx={{ mr: 2 }}
                        >
                            Cancel
                        </Button>
                        <Button className="mpl-primary-btn"
                        // onClick={handleUpdate}
                        >
                            Update
                        </Button>
                    </Box>
                </Box>
            </Popup>
        </>
    );
};

export default TeamBalanceGrid;